import React, { useCallback, useEffect, useState } from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import SportsSoccerRoundedIcon from '@mui/icons-material/SportsSoccerRounded';
import PlayerAvatar from './ui/PlayerAvatar';
import api from '../api';
import { dataPelada } from '../utils/dataPelada';
import useTempoReal from '../utils/tempoReal';

/**
 * Alerta "Com quem ficou a bola": as 2 últimas peladas (já fechadas) com essa marcação, com a data e
 * quem ficou com quantas bolas. Usado na Confirmação / Ordem de chegada e no Painel.
 */
const BolaAnteriorAlerta = ({ sx }) => {
  const [peladas, setPeladas] = useState([]);

  const carregar = useCallback(() => {
    api.get('v2/pelada/bolas/ultimas').then((r) => setPeladas(r.data.peladas || [])).catch(() => {});
  }, []);

  useEffect(() => {
    carregar();
  }, [carregar]);
  useTempoReal(carregar); // alguém informou/devolveu a bola: atualiza

  if (peladas.length === 0) return null;

  return (
    <Alert severity="warning" icon={<SportsSoccerRoundedIcon />} sx={{ mb: 2, '& .MuiAlert-message': { width: '100%' }, ...sx }}>
      <AlertTitle sx={{ fontWeight: 700 }}>Com quem ficou a bola</AlertTitle>
      <Stack spacing={1.25}>
        {peladas.map((p) => (
          <Box key={p.peladaId}>
            <Typography variant="caption" sx={{ fontWeight: 700, textTransform: 'capitalize', display: 'block', mb: 0.5 }}>
              Pelada de {dataPelada(p.date, { weekday: 'short', day: '2-digit', month: '2-digit' })} · {p.total} {p.total === 1 ? 'bola' : 'bolas'}
            </Typography>
            <Stack direction="row" spacing={0.75} useFlexGap flexWrap="wrap">
              {p.bolas.map((b) => (
                <Chip
                  key={`${p.peladaId}-${b.user}`}
                  size="small"
                  avatar={<PlayerAvatar userId={b.user} name={b.user_name} size={22} />}
                  label={`${b.user_name}${b.quantidade > 1 ? ` · ${b.quantidade} bolas` : ''}`}
                  sx={{ bgcolor: 'background.paper', fontWeight: 600 }}
                />
              ))}
            </Stack>
          </Box>
        ))}
      </Stack>
    </Alert>
  );
};

export default BolaAnteriorAlerta;
